<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <BoxIcon padding="8px" class="mr-3">
            <v-icon medium color="#fff">add</v-icon>
          </BoxIcon>
          <h1 style="display: inline">Crear ronda</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-stepper v-model="step">
          <v-stepper-header class="border-container bg-white">
            <v-stepper-step :complete="step > 1" step="1">
              <span class="text--primary">Datos</span>
            </v-stepper-step>
            <ArrowStep />
            <v-stepper-step :complete="step > 2" step="2">
              <span class="text--primary">Selección de alumnos</span>
            </v-stepper-step>
            <ArrowStep />
            <v-stepper-step :complete="step > 3" step="3">
              <span class="text--primary">Selección de tutores</span>
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <div class="options">
                    <v-card
                      flat
                      class="border-container"
                      style="overflow: visible"
                    >
                      <v-card-text class="py-4">
                        <strong class="text-uppercase">
                          ¿qué periodicidad tendrá la ronda?
                        </strong>
                        <v-radio-group v-model="form.optionDay" hide-details>
                          <RadioBox
                            :selected-value="form.optionDay"
                            value="EVENTUAL"
                            :up="true"
                            title="Solo un día"
                            description="Solo será valido para la fecha seleccionada."
                          />
                          <RadioBox
                            :selected-value="form.optionDay"
                            value="PERMANENT"
                            :down="true"
                            title="Por tiempo indefinido"
                            description="Será válido hasta que se elimine la ronda."
                          />
                        </v-radio-group>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-flex>
                <v-flex xs12 md6>
                  <div class="general_data">
                    <v-card
                      flat
                      class="border-container"
                      style="overflow: visible"
                    >
                      <v-card-text>
                        <v-container>
                          <v-layout align-center row fill-height>
                            <CircleNumber text="01" />
                            <span class="pl-2 subheading">
                              <strong>Datos generales</strong>
                            </span>
                          </v-layout>
                          <v-container>
                            <div
                              style="max-width: 300px"
                              v-on:mouseover="mouseOnImage = true"
                              v-on:mouseleave="mouseOnImage = false"
                            >
                              <v-flex
                                xs7
                                style="border-radius: 50%; cursor: pointer"
                                :class="[
                                  !modals.image ? 'gradiente' : '',
                                  'ma-auto',
                                ]"
                                @click="modals.showModalImage = true"
                              >
                                <v-img
                                  v-if="modals.image === undefined"
                                  :src="
                                    require('@/assets/panel/modals/AddPhotoIcon@3x.png')
                                  "
                                />
                                <v-avatar
                                  v-else
                                  size="100%"
                                  color="grey lighten-4"
                                >
                                  <v-img :src="modals.image" />
                                </v-avatar>
                              </v-flex>
                              <br />
                              <v-flex>
                                <v-expand-transition>
                                  <v-btn
                                    v-show="mouseOnImage"
                                    block
                                    class="gradiente"
                                    style="border-radius: 33px"
                                    dark
                                    @click="modals.showModalImage = true"
                                  >
                                    {{
                                      !modals.image
                                        ? 'Añadir foto'
                                        : 'Actualizar'
                                    }}
                                  </v-btn>
                                </v-expand-transition>
                              </v-flex>
                            </div>
                            <v-layout
                              align-start
                              column
                              fill-height
                              class="mt-2 ml-1"
                            >
                              <span class="font-weight-medium">
                                Nombre de la ronda
                              </span>
                              <input
                                type="text"
                                class="border-container mb-2 pa-2"
                                style="
                                  height: 40px;
                                  width: 100%;
                                  max-width: 300px;
                                  font-size: 1.2em;
                                "
                                v-model="form.name"
                              />
                              <v-layout column fill-height class="mt-2 ml-1">
                                <div v-if="form.optionDay === 'EVENTUAL'">
                                  <span style="width: 100px" class="mt-2 mr-2">
                                    <strong>Fecha de la ronda</strong>
                                  </span>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template late v-slot:activator="{ on }">
                                      <v-text-field
                                        id="first-small"
                                        :value="
                                          parseTimeFromTimePicker(
                                            form.dateStart
                                          )
                                        "
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      v-model="form.dateStart"
                                      :min="dateLimitToday"
                                    ></v-date-picker>
                                  </v-menu>
                                </div>
                              </v-layout>
                            </v-layout>
                            <v-layout justify-end row fill-height class="mt-4">
                              <v-btn
                                color="primary"
                                flat="flat"
                                class="border-container"
                                :disabled="!isValidToStep2Btn()"
                                @click="next"
                              >
                                Siguiente
                              </v-btn>
                            </v-layout>
                          </v-container>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class="border-container bg-white pa-4">
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-layout align-center row>
                      <CircleNumber text="02" />
                      <span
                        class="pl-2 subheading font-weight-medium text-uppercase"
                      >
                        Selecciona los alumnos para la ronda
                      </span>
                    </v-layout>
                    <div class="ml-3 mt-3">
                      <TargetAudience
                        :selected="form.target"
                        @selected="onSelected"
                        :is-round="true"
                      />
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-layout align-center row>
                      <span
                        class="pt-1 pl-2 subheading font-weight-medium text-uppercase"
                      >
                        Audiencia
                      </span>
                    </v-layout>
                    <div class="ml-3 mt-4 border-container">
                      <!-- INSTITUTION -->
                      <div
                        v-if="form.target === 'INSTITUTION'"
                        class="flex-align_center pa-3"
                      >
                        <BoxIcon>
                          <img
                            :src="require('@/assets/icons/office_building.svg')"
                            alt=""
                          />
                        </BoxIcon>
                        <p class="mt-3 mb-0 title font-weight-medium mb-1">
                          Institucional
                        </p>
                        <p
                          class="mb-0 text--secondary subheading font-weight-Regular mb-1"
                        >
                          Todos los alumnos pueden ser solicitados por la ronda
                        </p>
                      </div>

                      <!-- LEVELS -->
                      <div
                        v-if="form.target === 'LEVELS'"
                        class="flex-align_center pa-3"
                      >
                        <div>
                          <BoxIcon>
                            <v-icon color="white">school</v-icon>
                          </BoxIcon>
                          <input
                            type="text"
                            class="border-container ml-2 pa-2"
                            style="
                              height: 40px;
                              width: 100%;
                              max-width: 300px;
                              font-size: 1.2em;
                            "
                            v-model="levels.search"
                            @input="levels.searchItemsHandler()"
                          />
                        </div>
                        <p class="mt-3 mb-0 pb-2 title font-weight-medium">
                          Niveles
                        </p>
                        <CustomChip
                          v-for="item in levels.resultSearchedItems"
                          :is-selected="item.isSelected"
                          :text="item.levelName"
                          @click="levels.changeItem(item)"
                        />
                      </div>

                      <!-- EXTRA-LEVELS -->
                      <div
                        v-if="form.target === 'EXTRA_LEVELS'"
                        class="flex-align_center pa-3"
                      >
                        <div>
                          <BoxIcon>
                            <v-icon color="white">school</v-icon>
                          </BoxIcon>
                          <input
                            type="text"
                            class="border-container ml-2 pa-2"
                            style="
                              height: 40px;
                              width: 100%;
                              max-width: 300px;
                              font-size: 1.2em;
                            "
                            v-model="extraLevels.search"
                            @input="extraLevels.searchItemsHandler()"
                          />
                        </div>
                        <p class="mt-3 mb-0 pb-2 title font-weight-medium">
                          Niveles Extracurriculares
                        </p>
                        <CustomChip
                          v-for="item in extraLevels.resultSearchedItems"
                          :is-selected="item.isSelected"
                          :text="item.levelName"
                          @click="extraLevels.changeItem(item)"
                        />
                      </div>

                      <!-- GROUPS -->
                      <div
                        v-if="form.target === 'GROUPS'"
                        class="flex-align_center pa-3"
                      >
                        <div>
                          <BoxIcon>
                            <v-icon color="white">school</v-icon>
                          </BoxIcon>
                          <input
                            type="text"
                            class="border-container ml-2 pa-2"
                            style="
                              height: 40px;
                              width: 100%;
                              max-width: 300px;
                              font-size: 1.2em;
                            "
                            v-model="groups.search"
                            @input="groups.searchItemsHandler()"
                          />
                        </div>
                        <p class="mt-3 mb-0 pb-2 title font-weight-medium">
                          Grupos
                        </p>
                        <CustomChip
                          v-for="item in groups.resultSearchedItems"
                          :is-selected="item.isSelected"
                          :text="`${item.levelName}. ${item.groupName}`"
                          @click="groups.changeItem(item)"
                        />
                      </div>

                      <!-- SUB-GROUPS -->
                      <div
                        v-if="form.target === 'SUBGROUPS'"
                        class="flex-align_center pa-3"
                      >
                        <div>
                          <BoxIcon>
                            <v-icon color="white">school</v-icon>
                          </BoxIcon>
                          <input
                            type="text"
                            class="border-container ml-2 pa-2"
                            style="
                              height: 40px;
                              width: 100%;
                              max-width: 300px;
                              font-size: 1.2em;
                            "
                            v-model="subgroups.searchItems"
                            @input="subgroups.getItemsDebounced()"
                          />
                        </div>
                        <p class="mt-3 mb-0 pb-2 title font-weight-medium">
                          Subgrupos
                        </p>
                        <v-layout
                          v-if="students.loading"
                          align-center
                          justify-center
                          row
                          class="loading_height"
                        >
                          <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                          ></v-progress-circular>
                        </v-layout>
                        <div v-else class="items_box_pills">
                          <CustomChip
                            v-for="group in subgroups.resultSearchedItems"
                            :is-selected="group.isSelected"
                            :text="`${group.levelName}. ${group.groupName}`"
                            @click="subgroups.changeItem(group)"
                          />
                        </div>
                        <br />
                        <v-pagination
                          class="pagination"
                          v-model="subgroups.page"
                          :length="subgroups.totalPages"
                          @input="subgroups.changeItem(group)"
                        ></v-pagination>
                      </div>

                      <!-- STUDENTS -->
                      <div
                        v-if="form.target === 'STUDENTS'"
                        class="flex-align_center pa-3"
                      >
                        <div>
                          <BoxIcon>
                            <v-icon color="white">school</v-icon>
                          </BoxIcon>
                          <input
                            type="text"
                            class="border-container ml-2 pa-2"
                            style="
                              height: 40px;
                              width: 100%;
                              max-width: 300px;
                              font-size: 1.2em;
                            "
                            v-model="students.searchItems"
                            @input="students.getItemsDebounced()"
                          />
                        </div>
                        <p class="mt-3 mb-0 pb-2 title font-weight-medium">
                          Alumnos
                        </p>
                        <v-layout
                          v-if="students.loading"
                          align-center
                          justify-center
                          row
                          class="loading_height"
                        >
                          <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                          ></v-progress-circular>
                        </v-layout>
                        <div v-else class="items_box_pills">
                          <CustomChip
                            v-for="item in students.resultSearchedItems"
                            :is-selected="item.isSelected"
                            :text="item.fullName"
                            @click="students.changeItem(item)"
                          />
                        </div>
                        <br />
                        <v-pagination
                          class="pagination"
                          v-model="students.page"
                          :length="students.totalPages"
                          @input="students.getItems()"
                        ></v-pagination>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex>
                    <v-layout align-center justify-space-between class="pa-4">
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1"
                        @click="pevStep"
                      >
                        Atrás
                      </v-btn>
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1 pa-2"
                        :disabled="!isValidToStep3Btn()"
                        @click="goToStep3"
                      >
                        Siguiente
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-stepper-content>
            <v-stepper-content step="3">
              <div class="border-container bg-white pa-4">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout align-center row>
                      <CircleNumber text="03" />
                      <span
                        class="pl-2 subheading font-weight-medium text-uppercase"
                      >
                        Selecciona los tutores que pueden solicitar la ronda
                      </span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <div class="ml-3 mt-4 border-container">
                      <div class="flex-align_center pa-3">
                        <BoxIcon color="secondary">
                          <v-icon medium color="#fff">group</v-icon>
                        </BoxIcon>
                        <v-layout
                          align-center
                          justify-center
                          row
                          style="margin-top: -20px"
                        >
                          <v-flex xs6 md6 class="pa-0">
                            <v-text-field
                              v-model="searchTutor"
                              label="Buscar tutores"
                              class="border-container"
                              prepend-inner-icon="search"
                              clearable
                              solo
                              flat
                              hide-details
                              @click:clear="clearSearch"
                              @keyup.enter="getParentsRound"
                            />
                          </v-flex>
                        </v-layout>
                        <p class="my-3 title font-weight-medium">Tutores</p>
                        <v-card flat class="border-container mx-3">
                          <v-card-text class="px-0 py-0">
                            <v-data-table
                              v-model="selected"
                              :rows-per-page-items="[25, 50, 100]"
                              rows-per-page-text="Registros por página"
                              :headers="headers"
                              :items="items"
                              :total-items="totalItems"
                              :pagination.sync="pagination"
                              no-results-text="No se encontraron coincidencias"
                              no-data-text="No hay registros"
                              select-all
                              @update:pagination="getParentsRound"
                            >
                              <v-progress-linear
                                v-slot:progress
                                color="primary"
                                indeterminate
                              ></v-progress-linear>
                              <template v-slot:headers="props">
                                <tr>
                                  <th
                                    style="
                                      width: 78px;
                                      max-width: 78px;
                                      min-width: 78px;
                                    "
                                  >
                                    <v-checkbox
                                      :input-value="props.all"
                                      :indeterminate="props.indeterminate"
                                      primary
                                      color="primary"
                                      hide-details
                                      @click.stop="toggleAll"
                                    ></v-checkbox>
                                  </th>
                                  <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                  >
                                    {{ header.text }}
                                  </th>
                                </tr>
                              </template>
                              <template v-slot:items="props">
                                <tr>
                                  <td
                                    style="
                                      width: 78px;
                                      max-width: 78px;
                                      min-width: 78px;
                                    "
                                  >
                                    <v-checkbox
                                      color="primary"
                                      v-model="props.selected"
                                      primary
                                      hide-details
                                    >
                                    </v-checkbox>
                                  </td>
                                  <td>{{ props.item.firstName }}</td>
                                  <td>{{ props.item.lastName }}</td>
                                  <td>{{ props.item.email }}</td>
                                </tr>
                              </template>
                              <template v-slot:no-data>
                                No hay registros para filtrar
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex>
                    <v-layout align-center justify-space-between class="pa-4">
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1"
                        @click="pevStep"
                      >
                        Atrás
                      </v-btn>
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1 pa-2"
                        :disabled="!isValidCreateRound()"
                        @click="createRound"
                      >
                        Crear ronda
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </div>
    <EditImage
      title="Añadir imagen"
      v-on:loaded="processImage($event)"
      v-model="modals.showModalImage"
    />
    <Loading v-model="createOptions.loading" text="Creando ronda" />
    <Error v-model="createOptions.showError" :text="createOptions.message" />
    <Success
      v-model="createOptions.showSuccess"
      :text="createOptions.message"
    />
  </div>
</template>

<script>
import { debounce } from '../../../../../utils/genericUtils.js'
import Error from '../../../../Dialogs/Error.vue'
import Loading from '../../../../Dialogs/Loading.vue'
import Success from '../../../../Dialogs/Success.vue'
import EditImage from '../../../../Modals/EditImage.vue'
import ArrowStep from '../../../../generic/arrowStep.vue'
import BoxIcon from '../../../../generic/boxIcon.vue'
import CircleNumber from '../../../../generic/circleNumber.vue'
import CustomChip from '../../../../generic/customChip.vue'
import RadioBox from '../../../../generic/radioBox.vue'
import TargetAudience from '../../../../generic/targetAudience.vue'
import {
  ChipLevel,
  ChipStudent,
  parseChipStudentsFromArray,
  parseGroupsFromArray,
  parseLevelsFromArray,
  parseSubGroups,
} from '../utils.js'

class StudentsOrSubgroupHandler {
  constructor(targetId, api, apiUrl, itemParser) {
    this.targetId = targetId
    this.api = api
    this.apiUrl = apiUrl
    this.itemParser = itemParser
  }

  page = 1
  totalPages = 0
  selectedItemsIds = new Map()
  searchItems = ''
  /**
   * @type {Array<ChipLevel|ChipStudent>}
   */
  possibleItems = []
  /**
   * @type {Array<ChipLevel|ChipStudent>}
   */
  resultSearchedItems = []
  loading = false

  getItemsDebounced = debounce(this.getItems)

  getItems() {
    if (this.targetId === 'groupId') {
      this.getSubgroups()
    } else {
      this.getStudents()
    }
  }

  async getSubgroups() {
    const rowsPerPage = 25
    this.loading = true

    try {
      const filters = {
        search: this.searchItems.trim() === '' ? undefined : this.searchItems,
        page_size: rowsPerPage,
        offset: rowsPerPage * (this.page - 1),
      }
      const { data } = await this.api.dispatch(this.apiUrl, filters)
      const groups = this.itemParser(data.items)
      const totalPages = Math.ceil(data.total / rowsPerPage)

      this.totalPages = data.items.length === 0 ? 0 : totalPages
      this.possibleItems = groups
      this.resultSearchedItems = this.possibleItems
      this.setSelectedItems()
    } catch (error) {
      console.log(error)
      this.possibleItems = []
      this.resultSearchedItems = []
      this.totalPages = 0
    } finally {
      this.loading = false
    }
  }

  async getStudents() {
    const rowsPerPage = 25
    this.loading = true

    try {
      const filters = {
        search: this.searchItems.trim() === '' ? undefined : this.searchItems,
        size: rowsPerPage,
        offset: rowsPerPage * (this.page - 1),
      }
      const { data } = await this.api.dispatch(this.apiUrl, filters)

      const students = this.itemParser(data.entity)
      const totalPages = Math.ceil(data.size / rowsPerPage)

      this.totalPages = data.entity.length === 0 ? 0 : totalPages
      this.possibleItems = students
      this.resultSearchedItems = this.possibleItems
      this.setSelectedItems()
    } catch (error) {
      console.log(error)
      this.possibleItems = []
      this.resultSearchedItems = []
      this.totalPages = 0
    } finally {
      this.loading = false
    }
  }

  setSelectedItems() {
    this.possibleItems.forEach((el) => {
      if (this.selectedItemsIds.has(el[this.targetId])) {
        el.isSelected = true
      }
    })
  }

  changeItem(level = new ChipLevel()) {
    const index = this.possibleItems.findIndex(
      (e) => e[this.targetId] === level[this.targetId]
    )
    this.possibleItems[index].isSelected = !this.possibleItems[index].isSelected

    if (this.selectedItemsIds.has(level[this.targetId])) {
      this.selectedItemsIds.delete(level[this.targetId])
      return
    }

    this.selectedItemsIds.set(level[this.targetId], level[this.targetId])
  }
}

class LevelsGroupsHandler {
  constructor(targetId, itemParser, rawLevels) {
    this.targetId = targetId
    this.itemParser = itemParser
    this.setupItems(rawLevels)
  }

  targetId = ''
  page = 1
  totalPages = 0
  selectedItemsIds = new Map()
  search = ''
  /**
   * @type {Array<ChipLevel>}
   */
  possibleItems = []
  /**
   * @type {Array<ChipLevel>}
   */
  resultSearchedItems = []

  setupItems(rawLevels) {
    const items = this.itemParser(rawLevels)
    this.possibleItems = items
    this.resultSearchedItems = this.possibleItems
    this.setSelectedItems()
  }

  searchItemsHandler() {
    if (this.search.trim() === '') {
      this.resultSearchedItems = this.possibleItems
      return
    }

    this.resultSearchedItems = this.possibleItems.filter((e) =>
      `${e.levelName} ${e.groupName}`
        .toLowerCase()
        .includes(this.search.toLowerCase())
    )
  }

  setSelectedItems() {
    this.possibleItems.forEach((el) => {
      if (this.selectedItemsIds.has(el[this.targetId])) {
        el.isSelected = true
      }
    })
  }

  changeItem(level = new ChipLevel()) {
    const index = this.possibleItems.findIndex(
      (e) => e[this.targetId] === level[this.targetId]
    )
    this.possibleItems[index].isSelected = !this.possibleItems[index].isSelected

    if (this.selectedItemsIds.has(level[this.targetId])) {
      this.selectedItemsIds.delete(level[this.targetId])
      return
    }

    this.selectedItemsIds.set(level[this.targetId], level[this.targetId])
  }
}

export default {
  components: {
    CircleNumber,
    ArrowStep,
    TargetAudience,
    BoxIcon,
    RadioBox,
    CustomChip,
    Loading,
    Error,
    Success,
    EditImage,
  },
  data: () => ({
    headers: [
      {
        text: 'Nombre',
      },
      {
        text: 'Apellidos',
      },
      {
        text: 'Correo',
      },
    ],
    items: [],
    totalItems: 0,
    selected: [],
    modals: {
      showModalImage: '',
      image: undefined,
    },
    mouseOnImage: false,
    step: 1,
    dateLimitToday: '',
    form: {
      /**
       * @type {'PERMANENT'|'EVENTUAL'}
       */
      optionDay: 'EVENTUAL',
      dateStart: '',
      name: '',
      /**
       * @type {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'}
       */
      target: 'INSTITUTION',
    },
    breadcrumbs: [
      {
        text: 'Rondas',
        disabled: false,
        href: '/es/panel/rounds',
      },
      {
        text: 'Crear rondas',
        disabled: true,
        href: '/es/panel/rounds/create',
      },
    ],
    /**
     * @type {StudentsOrSubgroupHandler}
     */
    subgroups: undefined,
    /**
     * @type {LevelsGroupsHandler}
     */
    extraLevels: undefined,
    /**
     * @type {LevelsGroupsHandler}
     */
    levels: undefined,
    /**
     * @type {LevelsGroupsHandler}
     */
    groups: undefined,
    /**
     * @type {StudentsOrSubgroupHandler}
     */
    students: undefined,
    createOptions: {
      showSuccess: false,
      showError: false,
      loading: false,
      message: '',
    },
    pagination: {
      page: 1,
      rowsPerPage: 25,
    },
    searchTutor: '',
  }),
  async mounted() {
    this.initLevelsGradeGroupslevels().then((e) => {
      if (e === undefined) return

      this.extraLevels = new LevelsGroupsHandler(
        'levelId',
        parseLevelsFromArray,
        e.extracurricular
      )
      this.levels = new LevelsGroupsHandler(
        'levelId',
        parseLevelsFromArray,
        e.levels
      )
      this.groups = new LevelsGroupsHandler(
        'groupId',
        parseGroupsFromArray,
        e.levels
      )
    })

    this.subgroups = new StudentsOrSubgroupHandler(
      'groupId',
      this.$store,
      'subgroups/getSubgroups',
      parseSubGroups
    )
    this.students = new StudentsOrSubgroupHandler(
      'id',
      this.$store,
      'student/getStudentsByBranch',
      parseChipStudentsFromArray
    )

    this.dateLimitToday = new Date().toLocaleDateString('sv-SE')
    this.subgroups.getItems()
    this.students.getItems()
  },
  methods: {
    processImage(e) {
      this.modals.image = e
    },
    pevStep() {
      this.step = this.step - 1
    },
    next() {
      this.step = this.step + 1
    },
    async goToStep3() {
      this.next()
      this.getParentsRound()
    },
    clearSearch() {
      this.searchTutor = ''
      this.getParentsRound()
    },
    async getParentsRound() {
      const params = {
        institutional: this.form.target === 'INSTITUTION' ? true : undefined,
        levelIds:
          this.form.target === 'LEVELS'
            ? Array.from(this.levels.selectedItemsIds.values())
            : undefined,
        extraLevelIds:
          this.form.target === 'EXTRA_LEVELS'
            ? Array.from(this.extraLevels.selectedItemsIds.values())
            : undefined,
        gradeGroupIds:
          this.form.target === 'GROUPS'
            ? Array.from(this.groups.selectedItemsIds.values())
            : undefined,
        subgroupIds:
          this.form.target === 'SUBGROUPS'
            ? Array.from(this.subgroups.selectedItemsIds.values())
            : undefined,
        studentIds:
          this.form.target === 'STUDENTS'
            ? Array.from(this.students.selectedItemsIds.values())
            : undefined,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        size: this.pagination.rowsPerPage,
        search: this.searchTutor,
      }

      try {
        const { data } = await this.$store.dispatch(
          'round/getParentsRound',
          params
        )

        this.items = data.data
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
        this.items = []
        this.totalItems = 0
        this.createOptions.showError = true
        this.createOptions.message = 'Error al solicitar tutores'
      }
    },
    async createRound() {
      const body = {
        name: this.form.name,
        roundType: this.form.optionDay,
        image:
          this.modals.image !== undefined
            ? this.modals.image.split(',')[1]
            : undefined,
        date:
          this.form.optionDay === 'EVENTUAL'
            ? this._parseTimeToLocalEpoch(this.form.dateStart)
            : undefined,
        parentIds: this.selected.map((e) => e.id),
        institutional: this.form.target === 'INSTITUTION' ? true : undefined,
        levelIds:
          this.form.target === 'LEVELS'
            ? Array.from(this.levels.selectedItemsIds.values())
            : undefined,
        extraLevelIds:
          this.form.target === 'EXTRA_LEVELS'
            ? Array.from(this.extraLevels.selectedItemsIds.values())
            : undefined,
        gradeGroupIds:
          this.form.target === 'GROUPS'
            ? Array.from(this.groups.selectedItemsIds.values())
            : undefined,
        subgroupIds:
          this.form.target === 'SUBGROUPS'
            ? Array.from(this.subgroups.selectedItemsIds.values())
            : undefined,
        studentIds:
          this.form.target === 'STUDENTS'
            ? Array.from(this.students.selectedItemsIds.values())
            : undefined,
      }

      try {
        this.createOptions.loading = true
        await this.$store.dispatch('round/createCollegeRound', body)
        this.createOptions.message = 'Ronda creada con éxito.'
        this.createOptions.showSuccess = true
        const time = setTimeout(() => {
          this.$router.push({ name: 'Rounds' })
          clearTimeout(time)
        }, 2000)
      } catch (error) {
        console.log(error)
        const customErrors = {
          400: 'No se envió ningún elemento de la audiencia.',
        }
        this.createOptions.showSuccess = false
        this.createOptions.showError = true
        this.createOptions.message = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al crear ronda'
      } finally {
        this.createOptions.loading = false
      }
    },
    isValidCreateRound() {
      if (
        this.createOptions.loading ||
        this.createOptions.showSuccess ||
        this.createOptions.showError
      )
        return false

      return this.selected.length > 0
    },
    isValidToStep3Btn() {
      if (
        this.createOptions.loading ||
        this.createOptions.showSuccess ||
        this.createOptions.showError
      )
        return false

      if (this.form.target === 'INSTITUTION') {
        return true
      }
      if (this.form.target === 'GROUPS') {
        return this.groups.selectedItemsIds.size !== 0
      }
      if (this.form.target === 'LEVELS') {
        return this.levels.selectedItemsIds.size !== 0
      }
      if (this.form.target === 'EXTRA_LEVELS') {
        return this.extraLevels.selectedItemsIds.size !== 0
      }
      if (this.form.target === 'SUBGROUPS') {
        return this.subgroups.selectedItemsIds.size !== 0
      }
      if (this.form.target === 'STUDENTS') {
        return this.students.selectedItemsIds.size !== 0
      }

      return false
    },
    isValidToStep2Btn() {
      if (this.form.optionDay === 'EVENTUAL') {
        return this.form.dateStart === '' || this.form.name.trim() === ''
          ? false
          : true
      }

      return this.form.name.trim() === '' ? false : true
    },
    /**
     * accept a string like so `"2023-11-01"`
     */
    parseTimeFromTimePicker(date = '') {
      if (date === '') return ''

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    _parseTimeToLocalEpoch(date) {
      const [year, month, day] = date.split('-')
      return new Date(`${month}/${day}/${year}`).getTime()
    },
    onSelected(selected) {
      this.form.target = selected
    },
    async initLevelsGradeGroupslevels() {
      try {
        const { data } = await this.$store.dispatch('tutor/getLevelsExtraTool')

        return data.entity
      } catch (error) {
        console.log(error)
        return
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  /* padding: 1px; */
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.pagination {
  display: flex;
  justify-content: center;
}
.loading_height {
  height: 300px;
}
.items_box_pills {
  max-height: 300px;
  overflow-y: scroll;
}
/* reset global css */
::v-deep .v-btn {
  text-transform: initial;
}
::v-deep .v-stepper,
::v-deep .v-stepper__header {
  background-color: initial;
  box-shadow: none;
}
::v-deep .v-stepper__header {
  overflow: hidden;
}
::v-deep .v-stepper__content {
  padding-left: 0;
  padding-right: 0;
}
::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
/* generic */
.bg-white {
  background-color: white;
}
</style>
